/**
 * Sentry Error Tracking Configuration
 * Requires VITE_SENTRY_DSN environment variable to be set
 * @see https://docs.sentry.io/platforms/javascript/guides/react/
 */

import * as Sentry from '@sentry/react';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

// Initialize Sentry if DSN is provided (runtime check, not build-time)
// This prevents tree-shaking from removing the init code
export function initSentry() {
  if (SENTRY_DSN && import.meta.env.PROD) {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: import.meta.env.MODE,

      // Performance tracing sample rate (10% of transactions)
      tracesSampleRate: 0.1,

      // Capture React component stack in errors
      normalizeDepth: 10,

      // Filter sensitive data
      beforeSend(event) {
        // Remove sensitive headers if present
        if (event.request?.headers) {
          delete event.request.headers['Authorization'];
          delete event.request.headers['X-Admin-Restaurant-Id'];
        }
        return event;
      },
    });

    console.log('[Sentry] Initialized in', import.meta.env.MODE, 'environment');
  }
}

// Expose Sentry globally for console testing
if (typeof window !== 'undefined') {
  (window as unknown as { Sentry: typeof Sentry }).Sentry = Sentry;
}
